import React, { useState } from 'react'
import {allMushrooms} from '../mDatabase.js'
import MushroomItem from './MushroomItem.jsx'

const Mushrooms = () => {
  // eslint-disable-next-line
  const [mushroom] = useState(allMushrooms)
  return (
    <section key={mushroom.id} className='mushrooms'>
      <div className='container'> {
        mushroom.map(({id, familyHead, family, picture, species, 
          names, habitat, season, edibility, description}) => <MushroomItem key={id} mushroomID={id} familyHead={familyHead} family={family}
          picture={picture} species={species} names={names} habitat={habitat} season={season}
          edibility={edibility} description={description}></MushroomItem>)
      }
      </div>
    </section>
  )
}

export default Mushrooms